module.exports = __webpack_public_path__ + "odinstatic/v13.0.1/media/operator.be05c161.svg";